
import { BackupDto, BackupRestoreType, RestoreBackupDto } from '@/services/Backup/interfaces/index';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BackupDetailsDialog extends Vue {
  @Prop()
  public readonly backup!: BackupDto;

  public visible: boolean = true;

  public configVisible: boolean = false;
  public selectedConfig: unknown = null;

  public destroyComponent(): void {
    this.$emit('close');
  }

  public showConfig(config: unknown): void {
    this.selectedConfig = config;
    this.configVisible = true;
  }

  public restoreWebsiteBackup(websiteId: number): void {
    const data: RestoreBackupDto = {
      type: BackupRestoreType.WEBSITE,
      backupId: this.backup.id,
      websiteId,
    };

    this.$emit('restore', data);
  }

  public restoreDatabaseBackup(databaseId: number): void {
    const data: RestoreBackupDto = {
      type: BackupRestoreType.MYSQL,
      backupId: this.backup.id,
      databaseId,
    };
    this.$emit('restore', data);
  }
}
